// extracted by mini-css-extract-plugin
export var actionIcon = "_o0-0";